import { processInclude } from './util/common';
import QuickView from './product/quickView';
import ProductBox from './product/productBox';

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./search/search'));
    // processInclude(require('./product/wishlistHeart'));
    QuickView.run();
    ProductBox.run();
});

$(document).ready(function () {
    const expandableContainer = $('.ca-expandable');
    const expandButton = $('.ca-toggle-button-expand');
    const collapseButton = $('.ca-toggle-button-collapse');
    const toggleButtonContainer = $('.ca-toggle-button-container');
    const paddingOffset = parseInt($('.jsExpandPaddingReference').css('padding-bottom')) || 0;
    const referenceElementHeight = parseInt($('.jsExpandReference').outerHeight()) + paddingOffset;
    const expandedClass = 'ca-expanded';

    expandableContainer.css('max-height', referenceElementHeight + 'px');

    if (referenceElementHeight && expandableContainer.length > 0 && expandableContainer[0].scrollHeight > referenceElementHeight) {
        toggleButtonContainer.show();
    } else {
        toggleButtonContainer.hide();
    }

    expandButton.on('click', function () {
        const fullHeight = expandableContainer[0].scrollHeight;
        expandableContainer.addClass(expandedClass);
        expandableContainer.css('max-height', fullHeight + 'px');
        expandButton.hide();
        collapseButton.show();
    });

    collapseButton.on('click', function () {
        expandableContainer.removeClass(expandedClass);
        expandableContainer.css('max-height', referenceElementHeight + 'px');
        collapseButton.hide();
        expandButton.show();
    });
});

document.addEventListener('DOMContentLoaded', function () {
    $('.ca-faq-question').click(function () {
        $('.ca-faq-panel.show').css('max-height', '0');
    });
});

document.addEventListener('DOMContentLoaded', function (event) {
    var acc = document.getElementsByClassName('ca-faq-question');
    var panel = document.getElementsByClassName('ca-faq-panel');

    for (var i = 0; i < acc.length; i++) {
        acc[i].onclick = function () {
            var setClasses = !this.classList.contains('active');
            setClass(acc, 'active', 'remove');
            setClass(panel, 'show', 'remove');

            if (setClasses) {
                this.classList.toggle('active');
                this.nextElementSibling.classList.toggle('show');
                this.nextElementSibling.style.maxHeight =
                    this.nextElementSibling.scrollHeight + 'px';
            }
        };
    }

    function setClass(els, className, fnName) {
        for (var i = 0; i < els.length; i++) {
            els[i].classList[fnName](className);
        }
    }
});

(function () {
    window.addEventListener('load', (event) => {
        if (window.location.href.split('#').pop() == 'cookieconfig') {
            document.getElementsByClassName('ot-sdk-show-settings')[0].click();
        }
    });
})();

$(document).ready(function () {
    const faqSection = $('div.ca-faq-section');

    if (faqSection && faqSection.length) {
        const faqData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            'mainEntity': []
        };

        faqSection.find('div.ca-faq-container').find('div.ca-faq-accordion').each(function () {
            const question = $(this).find('h3.ca-faq-question').text();
            let answer = '';
            $(this).find('div.ca-faq-panel').find('div.ca-faq-answer').find('p').each(function () {
                answer += $(this).text() + ' ';
            });

            faqData.mainEntity.push({
                '@type': 'Question',
                'name': question,
                'acceptedAnswer': {
                    '@type': 'Answer',
                    'text': answer.trim()
                }
            });
        });

        const scriptTag = $('<script>', {
            type: 'application/ld+json',
            text: JSON.stringify(faqData)
        });

        $('head').append(scriptTag);
    }
});
